<div class="card">
    <div class="card-header flex justify-between items-center">
      <div class="exp">
        <h4 class="text-lg font-semibold">Amazon web service India private limited invoices</h4>
        <div class="flex-jc">
            <div>        
                <p>Total number of invoices<br> <strong>10</strong></p>
            </div>
            <div>
                <p>Total amount in USD <br><strong>USD 0.00</strong></p>

            </div>
        </div>
      </div>
    </div>
  
    <div class="card-body">
      <div class="input-group mb-4 w-50 mt-4">
        <span class="input-group-text bg-white border-end-0">
          <i class="fa-solid fa-magnifying-glass text-muted"></i>
        </span>
        <input
          type="text"
          [(ngModel)]="searchTerm"
          class="form-control border-start-0"
          placeholder="Filter by change type, document type or other properties"
        />
      </div>
  
      <table class="table table-striped table-bordered table-hover">
        <thead class="thead-light">
          <tr>
            <th (click)="sortBy('chargeType')" class="cursor-pointer">Charge Type ⬍</th>
            <th (click)="sortBy('documentType')" class="cursor-pointer">Document Type ⬍</th>
            <th (click)="sortBy('invoiceId')" class="cursor-pointer">Invoice ID ⬍</th>
            <th (click)="sortBy('invoiceDate')" class="cursor-pointer">Invoice Date(UTC) ⬍</th>
            <th (click)="sortBy('totalUsd')" class="cursor-pointer">Total in USD ⬍</th>
          </tr>
        </thead>
  
        <tbody>
          <ng-container *ngFor="let invoice of invoices">
            <tr>
              <td>{{ invoice.chargeType }}</td>
              <td>{{ invoice.documentType }}</td>
              <td>{{ invoice.invoiceId }}</td>
              <td>{{ invoice.invoiceDate }}</td>
              <td>{{ invoice.totalUsd }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
  